import { cloneElement, Fragment, type ReactElement, useState } from 'react';
import { formatCurrency } from '@recargas-dominicanas/core/utils';
import { DetailModal } from '../detail-modal/detail-modal.component';
import { DetailModalItem } from '../detail-modal-item/detail-modal-item.component';
import { useBusiness, useSalesReport } from '@recargas-dominicanas/core/store';
import { BusinessApi } from '@recargas-dominicanas/core/api';
import { printSalesReport } from '../../utils/printSalesReport';
import { ErrorModal } from '../error-modal/error-modal.component';
import { SalesReportSuccessfulModal } from '../sales-report-successful-modal/sales-report-successful-modal.component';

import {
  ModalContent,
  ModalActions,
  OutlineButton, 
  LoadingModal
} from '@recargas-dominicanas/core/components';

interface Props {
  children: ReactElement;
}

export function SalesReportModal(props: Props) {

  const { children } = props;

  const salesReportStore = useSalesReport();
  const business = useBusiness().get();
  const salesReport = salesReportStore.getCurrent();
  const [lastSalesReport, setLastSalesReport] = useState(salesReport);
  const [openModal, setOpenModal] = useState(false);
  const [openLoadingModal, setOpenLoadingModal] = useState(false);
  const [openErrorModal, setOpenErrorModal] = useState(false);
  const [openSuccessfulModal, setOpenSuccessfulModal] = useState(false);
 
  async function handleSalesReport() {
 
    try {
       
      setOpenModal(false);
      setOpenLoadingModal(true);
 
      const report = await BusinessApi.createSalesReport();
      await salesReportStore.fetchCurrent();
      await salesReportStore.fetchPage(1, 50);
       
      setLastSalesReport(report.salesReport);
      setOpenLoadingModal(false);
      setOpenSuccessfulModal(true);
 
    } catch {
 
      setOpenLoadingModal(false);
      setOpenErrorModal(true);
    }
  }

  async function handleOpen() {
    await salesReportStore.fetchCurrent();
    setOpenModal(true);
  }

  return (
    <Fragment>
      {cloneElement(children, { onClick: handleOpen } as any)}
      <DetailModal
        open={openModal} 
        title='Realizar cierre de ventas'
        onClose={() => setOpenModal(false)}>
        <ModalContent>
          <DetailModalItem title='Balance' color='green' text={formatCurrency(salesReport.balance)}/>
          <DetailModalItem title='Ventas' color='green' text={formatCurrency(salesReport.sales)}/>
          <DetailModalItem title='Balance consumido' color='green' text={formatCurrency(salesReport.sales - salesReport.profit)}/>
          <DetailModalItem title='Beneficio' color='green' text={formatCurrency(salesReport.profit)}/>
        </ModalContent>
        <ModalActions>
          <OutlineButton 
            text='Realizar'
            onClick={handleSalesReport}/>
        </ModalActions>
      </DetailModal>
      <LoadingModal
        open={openLoadingModal}
        title='Realizando cierre de ventas'
        overlayEnterAnimation={false}/>
      {lastSalesReport.date && 
        <SalesReportSuccessfulModal
          open={openSuccessfulModal}
          salesReport={lastSalesReport}
          onPrint={() => printSalesReport(business, lastSalesReport)}
          onClose={() => setOpenSuccessfulModal(false)}/>
      }
      <ErrorModal
        open={openErrorModal}
        title='Error realizando cierre de ventas'
        description='Ocurrio un error al realizar el cierre de ventas, intentelo denuevo más tarde.'
        onClose={() => setOpenErrorModal(false)}/>
    </Fragment>
  );
}
